<script setup lang="ts">

import Skeleton from 'primevue/skeleton'
</script>

<template>
  <div class="capsules-skeleton__wrapper">
    <div class="capsules-skeleton_header__wrapper">
      <div class="capsules-skeleton_header__wrapper_right">
        <Skeleton class="skeleton-header-imitation" borderRadius="40px"></Skeleton>
      </div>
      <div class="capsules-skeleton_header__wrapper_left">
        <Skeleton shape="circle" size="4rem"></Skeleton>
        <Skeleton shape="circle" size="4rem"></Skeleton>
      </div>
    </div>
    <div class="capsules-skeleton_content__wrapper">
      <div v-for="item in 5" class="skeleton">
        <Skeleton height="400px" borderRadius="40px"></Skeleton>
      </div>
      </div>
  </div>
</template>

<style scoped>

.skeleton {
  min-width: 300px;
}

.skeleton-header-imitation {
  width:100% !important;
  height:20px !important;
}

.capsules-skeleton_header__wrapper_right {
  display: flex;
  align-items: center;
  width:80%;
}


.capsules-skeleton__wrapper {
  display: flex;
  flex-direction: column;
  gap:40px;
  align-items: center;
  width:100%;
  overflow: hidden;
  padding:30px;
}

.capsules-skeleton_header__wrapper {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap:20px;
}

.capsules-skeleton_content__wrapper {
  display: flex;
  gap:30px;
  width:100%;
  max-width:90vw;
  overflow: hidden;
  justify-content: flex-start;
}

.capsules-skeleton_header__wrapper_left {
  display: flex;
  gap:20px
}

</style>